// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot_main {
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.forgot_box input {
    width: 100%;
    height: 46px;
    border: 1px solid #d1d5db !important;
    border-radius: 8px;
    padding: 0 14px !important;
    font-size: 16px;
    color: #111827;
    background-color: #f9fafb;
}

.forgot_box input::placeholder {
    font-size: 16px;
    color: #9ca3af;
}

.forgot_box input:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: #234B9A !important;
    background-color: #fff;
}

.forgot_box input::placeholder {
    color: #9ca3af;
    font-size: 13px;
}

input:focus {
    outline: none !important;
    box-shadow: none !important;
}

.form-control:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: #ced4da !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Auth/ForgotPass.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,gCAAgC;AACpC","sourcesContent":[".forgot_main {\n    width: 100%;\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n}\n\n.forgot_box input {\n    width: 100%;\n    height: 46px;\n    border: 1px solid #d1d5db !important;\n    border-radius: 8px;\n    padding: 0 14px !important;\n    font-size: 16px;\n    color: #111827;\n    background-color: #f9fafb;\n}\n\n.forgot_box input::placeholder {\n    font-size: 16px;\n    color: #9ca3af;\n}\n\n.forgot_box input:focus {\n    outline: none !important;\n    box-shadow: none !important;\n    border-color: #234B9A !important;\n    background-color: #fff;\n}\n\n.forgot_box input::placeholder {\n    color: #9ca3af;\n    font-size: 13px;\n}\n\ninput:focus {\n    outline: none !important;\n    box-shadow: none !important;\n}\n\n.form-control:focus {\n    outline: none !important;\n    box-shadow: none !important;\n    border-color: #ced4da !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
